module.exports = __webpack_public_path__ + "static/img/t1-5-3.bb7b077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-5-3.png
// module id = GR7Y
// module chunks = 1